var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c("div", { attrs: { id: "payment-type-options" } }, [
    _c(
      "button",
      { staticClass: "button-secondary", on: { click: _vm.createTransaction } },
      [
        _c("div", {
          staticClass: "sprite google-pay-light",
          attrs: { id: "googlepay-mark" },
        }),
      ]
    ),
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }